<div class="comparison-container">
  <div class="value-shell">
    <ng-container *ngFor="let value of rule.values; let i = index;">
      <div *ngIf="!value.isRemoved"
        class="value-wrapper"
        [ngSwitch]="valuesHidden ? -1 : currentComparison"
        [formGroup]="$any(valuesFormArray.at(i))">
        <!-- Text Is Or Select Is -->
        <div *ngIf="currentComparison === Comparisons.TextIs ||
          currentComparison === Comparisons.SelectIs"
          class="negate-or-wrapper"
          [class.is-first]="firstIndex === i">
          <yc-typeahead-select *ngIf="firstIndex === i"
            name="comparisonNegated"
            [dropdownPosition]="'bottom'"
            [items]="comparisonNegateOptions"
            [showClear]="false"
            (onChange)="negateChange($event)">
          </yc-typeahead-select>

          <span *ngIf="firstIndex !== i"
            class="or-label">
            <yc-i18n
              [key]="isNegated ? 'GLOBAL:lblAND' : 'GLOBAL:lblOR'"
              [defaultValue]="isNegated ? 'and' : 'or'">
            </yc-i18n>
          </span>
        </div>

        <!-- Number Is -->
        <div *ngIf="currentComparison === Comparisons.NumberIs"
          class="me-3"
          [class.mt-2]="firstIndex !== i">
          <yc-typeahead-select
            class="flex-grow-1"
            name="comparisonNegated"
            [dropdownPosition]="'bottom'"
            [items]="numberIsOptions"
            [showClear]="false"
            (onChange)="negateChange($event)">
          </yc-typeahead-select>
        </div>

        <!-- Number Range -->
        <div *ngSwitchCase="Comparisons.NumberRange"
          class="d-flex flex-grow-1">
          <yc-typeahead-select
            class="me-2 flex-basis-50"
            name="comparisonNegated"
            [dropdownPosition]="'bottom'"
            [items]="numberRangeOptions"
            [showClear]="false"
            (onChange)="negateChange($event)">
          </yc-typeahead-select>

          <!-- Number Range Selected -->
          <div *ngIf="!isCdtComparison"
            class="flex-basis-50 d-flex">
            <yc-input
              [isNumber]="true"
              name="comparisonGreaterThan"
              placeholder="0.00">
            </yc-input>
            <span>
              {{ ' - ' }}
            </span>
            <yc-input
              [isNumber]="true"
              name="comparisonLessThan"
              placeholder="999,999,999.99">
            </yc-input>
          </div>

          <!-- CDT Comparison -->
          <div *ngIf="isCdtComparison"
            class="flex-basis-50">
            <ng-template *ngTemplateOutlet="cdtComparisonValue"></ng-template>
          </div>
        </div>

        <!-- Date Range -->
        <div *ngSwitchCase="Comparisons.DateRange"
          class="flex-grow-1">
          <!-- type selector -->
          <yc-typeahead-select
            class="me-3 min-width"
            name="comparisonType"
            [dropdownPosition]="'bottom'"
            [showClear]="false"
            [items]="dateOptions"
            (onChange)="setRule()">
          </yc-typeahead-select>
          <!-- date options for in between -->
          <ng-container *ngIf="isBetween">
            <yc-datepicker
              class="max-width-date"
              name="comparisonGreaterThan"
              [placeholder]="'GLOBAL:textStartDate' | ycI18n: 'Start date'">
            </yc-datepicker>
            <span>
              {{ ' - ' }}
            </span>
            <yc-datepicker
              class="max-width-date"
              name="comparisonLessThan"
              [placeholder]="'GLOBAL:textEndDate' | ycI18n: 'End date'">
            </yc-datepicker>
          </ng-container>
        </div>

        <!-- Is Selected -->
        <div *ngSwitchCase="Comparisons.IsSelected"
          class="flex-grow-1"
          [class.mt-2]="firstIndex !== i">    
          <yc-typeahead-select
            name="comparisonValue"
            [dropdownPosition]="'bottom'"
            [items]="columnComparisonOptions?.length ?
              columnComparisonOptions :
              selectedOptions">
          </yc-typeahead-select>
        </div>

        <!-- Is Uploaded -->
        <div *ngSwitchCase="Comparisons.IsUploaded"
          class="flex-grow-1"
          [class.mt-2]="firstIndex !== i">
          <yc-typeahead-select
            name="comparisonValue"
            [dropdownPosition]="'bottom'"
            [items]="fileUploadedOptions">
          </yc-typeahead-select>
        </div>

        <!-- Select Is -->
        <div *ngSwitchCase="Comparisons.SelectIs"
          class="flex-grow-1"
          [class.mt-2]="firstIndex !== i">
          <yc-typeahead-select *ngIf="!isCdtComparison"
            name="comparisonValue"
            [dropdownPosition]="'bottom'"
            [showClear]="false"
            [items]="columnComparisonOptions">
          </yc-typeahead-select>
          
          <!-- CDT Comparison -->
          <ng-container *ngIf="isCdtComparison">
            <ng-template *ngTemplateOutlet="cdtComparisonValue"></ng-template>
          </ng-container>

        </div>

        <!-- Text Is -->
        <div *ngSwitchCase="Comparisons.TextIs"
          class="flex-grow-1"
          [class.mt-2]="firstIndex !== i">
          <yc-input *ngIf="!isCdtComparison"
            name="comparisonValue">
          </yc-input>

          <!-- CDT Comparison -->
          <ng-container *ngIf="isCdtComparison">
            <ng-template *ngTemplateOutlet="cdtComparisonValue"></ng-template>
          </ng-container>
        </div>

        <!-- Number Is -->
        <div *ngSwitchCase="Comparisons.NumberIs"
          class="flex-grow-1"
          [class.mt-2]="firstIndex !== i">
          <yc-input
            name="comparisonValue"
            [isNumber]="true"
            [min]="0">
          </yc-input>
        </div>

        <!-- Majority -->
        <div *ngSwitchCase="Comparisons.Majority"
          class="flex-grow-1"
          [class.mt-2]="firstIndex !== i">
          <yc-typeahead-select
            name="comparisonValue"
            [dropdownPosition]="'bottom'"
            [showClear]="false"
            [items]="majorityOptions">
          </yc-typeahead-select>
        </div>

        <div *ngSwitchDefault class="default-holder"></div>

        <!-- Remove -->
        <yc-button *ngIf="!value.isRemoved"
          [icon]="true"
          [value]="'common:textRemove' | ycI18n: 'Remove'"
          class="ms-2"
          (onClick)="removeValue(i)">
          <yc-fa
            icon="times"
            class="text-danger"
            [light]="true">
          </yc-fa>
        </yc-button>

        <!-- CDT Comparision Value Selector -->
        <ng-template #cdtComparisonValue>
          <yc-typeahead-select
            name="comparisonValue"
            [dropdownPosition]="'bottom'"
            [showClear]="false"
            [items]="currentComparison === Comparisons.NumberRange ?
              cdtComparisonNumberOptions :
              cdtComparisonOptions">
          </yc-typeahead-select>
        </ng-template>
      </div>
    </ng-container>

    <div *ngIf="!showOrButton" class="mb-4"></div>

    <yc-button *ngIf="showOrButton"
      class="add-button"
      [secondary]="true"
      (onClick)="addValue()">
      <yc-fa icon="plus" [light]="true"></yc-fa>
      <yc-i18n
        [key]="isNegated ? 'GLOBAL:lblAND' : 'GLOBAL:lblOR'"
        [defaultValue]="isNegated ? 'AND' : 'OR'">
      </yc-i18n>
    </yc-button>
  </div>
</div>
